import { Injectable } from '@angular/core';
import { DefineBootboxId } from 'app/resources/classes';

@Injectable()
export class LojaCarrinhoService {

  public itens = [];
  public valor = undefined;
  public pontos = undefined;
  public parceiro = undefined;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  public destinatario = {
    nome: undefined,
    documento: undefined,
    email: undefined,
    telefone: undefined
  };
  public enderecoEntrega = {
    logradouro: undefined,
    numero: undefined,
    complemento: undefined,
    bairro: undefined,
    cep: undefined,
    cidade: undefined,
    uf: undefined
  };
  public frete = {
    frete: undefined,
    valor: undefined,
    pontos: undefined
  };

  constructor() { }

  public add(produto) {
    let itemEncontrado = undefined;

    if (this.parceiro.id !== produto.categoria.parceiro.id) {
      this.bootboxAlertComId.alerta('Erro! Não é permitido incluir produtos de parceiros diferentes no carrinho!');
      return;
    }

    for (let i = 0; i < this.itens.length; i++) {
      const p = this.itens[i].produto;
      if (p.sku === produto.sku) {
        itemEncontrado = this.itens[i];
        break;
      }
    }

    if (itemEncontrado) {
      itemEncontrado.quantidade += 1;
    } else {
      const item = {
        produto: produto
        , parceiro: this.parceiro
        , produtoSku: produto.sku
        , produtoCodigo: produto.codigo
        , produtoNome: produto.nome
        , produtoPrecoPor: produto.precoPor
        , produtoPrecoPormoeda: produto.moeda
        , quantidade: 1
      };
      this.itens.push(item);
    }
  }

  public remove(produto) {
    if (this.parceiro.id !== produto.categoria.parceiro.id) {
      this.bootboxAlertComId.alerta('Erro! Não é permitido produtos de parceiros diferentes no carrinho!');
      return;
    }

    for (let i = 0; i < this.itens.length; i++) {
      const p = this.itens[i].produto;

      if (p.sku === produto.sku) {
        if (this.itens[i].quantidade === 1) {
          this.itens = this.itens.filter(function (item) {
            if (item.produto.sku !== p.sku) {
              return item;
            }
          });
        } else {
          this.itens[i].quantidade -= 1;
        }
        break;
      }
    }
  }

  public clean() {
    this.itens = [];
  }

  public totalItens() {
    let totalItens = 0;

    for (let i = 0; i < this.itens.length; i++) {
      totalItens += this.itens[i].quantidade;
    }
    return totalItens;
  }

  public totalPontos() {
    let pontos = 0;
    for (let i = 0; i < this.itens.length; i++) {
      pontos += this.itens[i].produto.pontos * this.itens[i].quantidade;
    }
    return pontos;
  }

  public limpar() {
    this.itens = [];
    this.valor = undefined;
    this.pontos = undefined;
    this.parceiro = undefined;
    this.destinatario = {
      nome: undefined,
      documento: undefined,
      email: undefined,
      telefone: undefined
    };
    this.enderecoEntrega = {
      logradouro: undefined,
      numero: undefined,
      complemento: undefined,
      bairro: undefined,
      cep: undefined,
      cidade: undefined,
      uf: undefined
    };
    this.frete = {
      frete: undefined,
      valor: undefined,
      pontos: undefined
    };


  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/loja-carrinho.service.ts